export const SET_CHOICE_DSR_FOR = 'SET_CHOICE_DSR_FOR';
export const SET_DSR_STATE = 'SET_DSR_STATE';
export const SET_VISIBLE_GLOBAL_MODAL_CONTENT = 'SET_VISIBLE_GLOBAL_MODAL_CONTENT';
